import * as yup from "yup";
import { convertDateToString } from "../utility/ConvertUtily";

const now = new Date();
export const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
//let tempDatetime: Date;

export type OptionContract = {
  id: string;
  optionId: string;
  optionName: string;
  status: boolean;
  applicableStartDate: Date | null;
  applicableFinishDate: Date | null;
  sort?: number;
};

// オプション契約の初期値
export const initOptionContract = (): OptionContract[] => {
  return [
    {
      id: "",
      optionId: "userIdCard",
      optionName: "利用者IDカード",
      status: false,
      applicableStartDate: null,
      applicableFinishDate: null,
    }
  ];
};

export const optionContractTimestampToDate = (data: any | undefined): OptionContract => {
  if(data.applicableStartDate !== null){
    const startDate = new Date(data.applicableStartDate.seconds * 1000);
    data.applicableStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  }
  if(data.applicableFinishDate !== null){
    const finishDate = new Date(data.applicableFinishDate.seconds * 1000);
    data.applicableFinishDate = new Date(finishDate.getFullYear(), finishDate.getMonth(), finishDate.getDate());
  }
  return data;
};

export const optionContractSchema = yup.object({
  applicableStartDate: yup.date().test((value, testContext) => {
    const startDate = testContext.parent.applicableStartDate;
    if(startDate < nowDate){
      return testContext.createError({
        message: `${convertDateToString(nowDate)}より後でなければなりません。`
      })
    }
    return true;
  }),
  applicableFinishDate: yup.date().test((value, testContext) => {
    const finishDate = testContext.parent.applicableFinishDate;
    const startDate = testContext.parent.applicableStartDate;
    if(!Number.isNaN(startDate.getTime()) && !Number.isNaN(finishDate.getTime()) && finishDate <= startDate){
      return testContext.createError({
        message: `${convertDateToString(startDate)}より後でなければなりません。`
      })
    }
    return true;
  }),
})
